<template> 
    <div class="row g-6 g-xl-9">  
        <div class="col-12 col-md-12 col-xl-12"> 
            <EnderecoIndex/>  
        </div> 
    </div>  
</template>

<script lang="ts">
    import EnderecoIndex from   "./_Index.vue"  
    import { Options, Vue  } from "vue-class-component";   
      
    @Options({
        name: "Cursos",
        components: { EnderecoIndex },  
    }) 
    export default class Cursos extends Vue {
         
    }
</script> 